"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import React from 'react';

const LevelKeysConflictContext = React.createContext(/* @__PURE__ */ new Set());
const LevelKeysConflictProvider = LevelKeysConflictContext.Provider;
const useLevelKeysConflicts = () => React.useContext(LevelKeysConflictContext);

export { LevelKeysConflictProvider, useLevelKeysConflicts };
